import { FormTypeViewGeneratedEntity } from "./generated/FormTypeViewGeneratedEntity";

export abstract class FormTypeViewEntity extends FormTypeViewGeneratedEntity {
    // Comment to preserve new line
}
